import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";

function Index() {
  const auth = useContext(AuthContext);
  return auth;
}

export default Index;
